exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-left-status[data-v-56785a8a] {\n  margin-right: 5px;\n}\n.content-line[data-v-56785a8a] {\n  padding: 12px;\n  margin-bottom: 5px;\n  border-radius: 5px;\n}\n.content-line-1[data-v-56785a8a] {\n  padding: 6px;\n  margin-bottom: 5px;\n  border-radius: 5px;\n}\n.color-1[data-v-56785a8a] {\n  background: #c694f9;\n}\n.color-2[data-v-56785a8a] {\n  background: #6aa5e3;\n}\n.color-3[data-v-56785a8a] {\n  background: #feb683;\n}\n.color-4[data-v-56785a8a] {\n  background: #ef5b5b;\n}\n.button-bottom[data-v-56785a8a] {\n  border-radius: 0;\n  margin-left: 3px;\n}\n", ""]);

// exports
